export const modifiedReasonConfig = [
    'publicCommissionTypes',
    'roles',
    'users',
    'accountingExternalTransactions',
    'accountingGatewayAccounts',
    'accountingGatewayTransactions',
    'accountingWalletTransfers',
    'accountingGatewayWalletTransfers',
    'accountingSystemAccounts',
    'accountingSystemTransactions',
    'accountingWithdrawalTransactions',
    'accountingAgentTransactions',
    'publicGatewayApis',
    'publicGatewaySettings',
    'publicGateways',
    'publicTgBots',
    'publicTgSessions',
    // Saving a scenario changes what every gateway using it runs, from the next
    // call on — the kind of edit that wants a recorded reason.
    'publicScraperScenarios',
    'publicTerminalShopWindows',
    'publicMerchantTerminalGateways',
    'publicMerchantTerminals',
    'publicMerchants',
    'publicAppeals',
    'publicChargebacks',
    'publicFrauds',
    'publicCommissions',
    'cryptoCoins'
];
